export default function () {
    document.addEventListener("keyup", function(e) {
        if (e.target.matches(".document-list-filter input")) {
            const input = e.target;
            const parent = input.closest(".document-list");
            if (!parent) return;

            applyDocumentFilter(parent);
        }
    });

    document.addEventListener("click", function(e) {
        if (e.target.matches(".document-list-filter button")) {
            const button = e.target;
            const parent = button.closest(".document-list");
            if (!parent) return;

            if (button.classList.contains("uk-active")) button.classList.remove("uk-active");
            else button.classList.add("uk-active");

            applyDocumentFilter(parent);
        }
    });

    function applyDocumentFilter(parent) {
        if (!parent) return;
        const input = parent.querySelector("input");
        const text = input.value ?? "";

        const activeButtons = parent.querySelectorAll("button.uk-active");
        const activeTags = [...activeButtons].map(button => button.getAttribute("data-filter-tag"));

        const noMatchesFound = parent.querySelector(".no-matches-found");
        const items = parent.querySelectorAll(".document");

        noMatchesFound.style.display = "none";

        let showNoMatchesFound = true;
        items.forEach(item => {
            let show = true;

            if (text.length > 0 && !item.getAttribute("data-filter-text").toLowerCase().includes(text.toLowerCase()))
                show = false;

            const tags = item.getAttribute("data-filter-tags")?.split("|").map(tag => tag.toLowerCase()) ?? [];
            if (activeTags.length > 0 && (tags.length == 0 || !activeTags.every(activeTag => tags.includes(activeTag.toLowerCase())))) show = false;

            if (show) {
                item.style.display = "block";
                showNoMatchesFound = false;
            } else {
                item.style.display = "none";
            }
        });
        
        if (showNoMatchesFound)
            noMatchesFound.style.display = "block";
    }
}